import Vue from 'vue'
import Vuex from 'vuex'
import {AppState, getDefaultState} from "@/store/app-state";
import {getters} from "@/store/getters";
import {mutations} from "@/store/mutations";
import {actions} from "@/store/actions";

Vue.use(Vuex);

const store = new Vuex.Store<AppState>({
  state: getDefaultState(),
  getters: getters,
  mutations: mutations,
  actions: actions
});

export default store;
